import { __extends } from "tslib";
import { AVMStage } from "@awayfl/swf-loader";
import { AVM1Handler } from '@awayfl/avm1';
var AVM1Player = /** @class */ (function (_super) {
    __extends(AVM1Player, _super);
    function AVM1Player(gameConfig) {
        var _this = _super.call(this, gameConfig) || this;
        _this.registerAVMStageHandler(new AVM1Handler());
        return _this;
    }
    return AVM1Player;
}(AVMStage));
export { AVM1Player };
